import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_90: DocMigration = {
  maxSchemaVersion: "0.0.90",
  description: "Fix bug on foundation migration from 0.0.90",
  apply(json: any) {
    if (json.foundations) {
      for (const foundationId in json.foundations) {
        if (json.foundations[foundationId].type === "SLAB") {
          json.foundations[foundationId].type = "SLAB_ON_GRADE";
        }
      }
    }

    return json;
  },
};

export default migration_0_0_90;
